<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
			<path
				class="light"
				d="M380.7 67.31C351.6 38.22 304.4 38.22 275.3 67.31L83.31 259.3C36.54 306.1 36.54 381.9 83.31 428.7C130.1 475.5 205.9 475.5 252.7 428.7L404.7 276.7C410.9 270.4 421.1 270.4 427.3 276.7C433.6 282.9 433.6 293.1 427.3 299.3L275.3 451.3C216 510.6 119.1 510.6 60.69 451.3C1.417 392 1.418 295.1 60.69 236.7L252.7 44.69C294.3 3.092 361.7 3.092 403.3 44.69C444.9 86.28 444.9 153.7 403.3 195.3L219.5 379.1C191.3 407.3 144.9 404.7 119.1 373.6C98.67 346.1 100.8 308.6 124.9 284.5L276.7 132.7C282.9 126.4 293.1 126.4 299.3 132.7C305.6 138.9 305.6 149.1 299.3 155.3L147.5 307.1C134.1 319.7 133.8 339.7 144.1 353.6C157.1 369.8 182.2 371.2 196.9 356.5L380.7 172.7C409.8 143.6 409.8 96.41 380.7 67.31L380.7 67.31z"
			/>

			<path
				class="regular"
				d="M375 72.97C349.1 46.1 306.9 46.1 280.1 72.97L88.97 264.1C45.32 308.6 45.32 379.4 88.97 423C132.6 466.7 203.4 466.7 247 423L399 271C408.4 261.7 423.6 261.7 432.1 271C442.3 280.4 442.3 295.6 432.1 304.1L280.1 456.1C218.6 519.4 117.4 519.4 55.03 456.1C-7.364 394.6-7.364 293.4 55.03 231L247 39.03C291.7-5.689 364.2-5.689 408.1 39.03C453.7 83.75 453.7 156.3 408.1 200.1L225.2 384.7C193.6 416.3 141.6 413.4 113.7 378.6C89.88 348.8 92.26 305.8 119.2 278.8L271 127C280.4 117.7 295.6 117.7 304.1 127C314.3 136.4 314.3 151.6 304.1 160.1L153.2 312.7C143.5 322.4 142.6 337.9 151.2 348.6C161.2 361.1 179.9 362.2 191.2 350.8L375 167C401 141.1 401 98.94 375 72.97V72.97z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'PaperclipIcon',
	components: { Icon },
	props,
}
</script>
